"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CurrentFastenerWidget_1 = __importDefault(require("./CurrentFastenerWidget"));
exports.default = CurrentFastenerWidget_1.default;
